/* eslint-disable react-hooks/exhaustive-deps */

import React from 'react';
import PropTypes from 'prop-types';
import Body from 'iovisit-theme/components/Blocks/Contacts/Body';

const View = (props) => {
  return <Body {...props} />;
};

View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default View;
